import React from "react";
import { CastProvider } from 'react-cast-sender';
import { Detector } from 'react-detect-offline';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ErrorBoundary from '../3Organisms/ErrorBoundary';
import SEO from "../seo";
import Weather from './Weather';
import "./../../styles/main.scss";

export default function WeatherWrapperPlain(props) {
  toast.configure();

  // const {
  //   loadMedia,
  //   currentTime,
  //   duration,
  //   isPaused,
  //   isMediaLoaded,
  //   togglePlay,
  //   seek,
  //   isMuted,
  //   tracks,
  //   editTracks,
  //   thumbnail,
  //   title,
  //   setVolume,
  //   toggleMute
  // } = useCastPlayer();

  return (
    (typeof window !== 'undefined' && CastProvider) && 
    <>
      <div className="content">
        <CastProvider receiverApplicationId='default'>  
          <ErrorBoundary>
              <Detector
                render={({ online }) => (
                  <Weather 
                    online={true}
                    user={props.user}
                    loading={props.loading}
                    showLogin={props.showLogin}
                    setShowLogin={props.setShowLogin}
                  /> 
                )}
            />
          </ErrorBoundary>
        </CastProvider>
        <ToastContainer limit={1} />      
      </div>
    </>
  )
}

export const WeatherWrapper = React.memo(WeatherWrapperPlain);